<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Reward Funnel Tests</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>

        <ion-item-divider color="tertiary">
            Test Trial Period - Expiration Date Rewards
        </ion-item-divider>
    
        <ion-item [disabled]=vb.disabled detail="true" data-test="reset1Test" href="javascript:;" (click)="onReset1Click()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Reset To Beginning Of Trial Period</span><br />
                <span class="line2">Expect a message in the Message Center.</span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="reset2Test" href="javascript:;" (click)="onReset2Click()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Reset to 7 Days Before Expiration</span><br />
                <span class="line2">Expect a message in the Message Center.</span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="reset3Test" href="javascript:;" (click)="onReset3Click()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Reset to 3 Days Before Expiration</span><br />
                <span class="line2">Expect a message in the Message Center.</span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="reset4Test" href="javascript:;" (click)="onReset4Click()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Reset to 0 Days Before Expiration</span><br />
                <span class="line2">Expect a message in the Message Center.</span>
            </ion-label>
        </ion-item>

        <ion-item-divider color="tertiary">
            Test Testimoanial Rewards - Coupon Rewards
        </ion-item-divider>

        <ion-item [disabled]=vb.disabled detail="true" data-test="reset4Test" href="javascript:;" (click)="onReset4Click()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Reset to 0 Days Before Expiration</span><br />
                <span class="line2">Expect a message in the Message Center.</span>
            </ion-label>
        </ion-item>

        <ion-item [disabled]=vb.disabled detail="true" data-test="reset4Test" href="javascript:;" (click)="onReset4Click()">
            <ion-label class="ion-text-wrap">
                <span class="line1">Reset to 0 Days Before Expiration</span><br />
                <span class="line2">Expect a message in the Message Center.</span>
            </ion-label>
        </ion-item>

    </ion-list>
</ion-content>
